import { httpGet as utilsGet, httpPost } from "@bilibili/growup-utils/_esm5/http";
import { getLoginByCallback, toast } from "@bilibili/growup-utils/_esm5/index";
import { apiPrefix, ACTIVITY_UID, domain } from "@/utils/config";
import { IWithdrawParams } from "@/types";

export enum SharePanelType {
  Resident,
  Portal
}
export enum TaskStatus {
  HasTask,
  NotHasTask
}
export interface SharePanelShowNeed {
  taskStatus: TaskStatus;
  useCommandChannel: boolean;
}

function debounce(fn, timeout) {
  let time;
  let running = false;
  return function(...args) {
    if (!running) {
      running = true;
      // @ts-ignore
      // eslint-disable-next-line
      fn.apply(this, args);
    }

    clearTimeout(time);
    time = setTimeout(() => {
      running = false;
    }, timeout);
  };
}

const debounceLogin = debounce(() => {
  getLoginByCallback();
}, 1000);

const debounceToast = debounce((msg) => {
  toast(msg);
}, 500);

function httpGet(url, params?: any) {
  return utilsGet(url, {
    ...(params || {}),
    needLogin: false,
    hideError: true
  }).then((res) => {
    if (res?.code === -101 && (params?.needLogin ?? true)) {
      debounceLogin();
    }
    if (res?.code !== 0 && res?.message && !(params ? params.hideError : true)) {
      debounceToast(res.message);
    }
    return res;
  });
}

// 充能
export function chargeDo(mid: number | string) {
  return httpPost(`${apiPrefix}/invite/do`, {
    data: {
      activity_uid: ACTIVITY_UID,
      mid
    },
    hideError: true
  });
}

/* 活动页http接口
 * https://info.bilibili.co/pages/viewpage.action?pageId=598841391
 */

/**
 * 奖品列表 我的奖品 + 已获得奖品
 * @param {number} activity_type
 */
export function getAwards(activity_type: number = 1) {
  return httpGet(`${domain}/x/platform/activity/awards`, {
    query: {
      activity_type
    },
    needLogin: true,
    hideError: true
  });
}

/**
 * 任务模块 获取用户任务信息
 * @param {number} activity_type
 */
export function getTaskInfo(activity_type: number = 1) {
  return httpGet(`${domain}/x/platform/activity/task`, {
    query: {
      activity_type
    },
    needLogin: true,
    hideError: true
  });
}

/**
 * 宝藏视频
 * @param {number} activity_type
 */
export function getVideos(activity_type: number = 1) {
  return httpGet(`${domain}/x/platform/activity/videos`, {
    query: {
      activity_type
    },
    hideError: true
  });
}

/**
 * 剩余信息 获奖跑马灯 + 活动Banner图
 * @param {number} activity_type
 */
export function getMixedActivityInfo(activity_type: number = 1) {
  return httpGet(`${domain}/x/platform/activity/mixedActivityInfo`, {
    query: {
      activity_type
    },
    hideError: true
  });
}
export function postGetWatchWord(token: string, activity_uid: string): Promise<{ watchword: string }> {
  return httpPost(`${domain}/x/fission/share/watchword/out`, {
    data: {
      activity_uid,
      token: token
    }
  }).then(({ code, data, message }) => {
    if (code === 0) {
      return { watchword: `11${data.watchword + data.watchword_desc}` };
    } else {
      throw new Error(message);
    }
  });
}
/**
 * 用户屏蔽活动
 * @param {number} activity_type
 */
export function blockActivity(activity_type: number = 1) {
  return httpPost(`${domain}/x/platform/activity/block`, {
    data: {
      activity_type
    },
    needLogin: true
  });
}

/**
 * 用户点击奖品“去查看”按钮，上报用户点击行为
 * @param {number} activity_type
 * @param {string} award_id
 */
export function clickAward(award_id: string, activity_type: number = 1) {
  return httpPost(`${domain}/x/platform/activity/award/click`, {
    data: {
      activity_type,
      award_id
    },
    needLogin: true
  }).then(({ code, message }) => {
    if (code !== 0) {
      debounceToast(message);
    }
  });
}

/**
 * 拉新任务提现
 * @param {string} activity_uid
 * @param {number} id
 * @param {from} number
 */
export function withdraw(params: IWithdrawParams) {
  return httpPost(`${apiPrefix}/invite/withdraw`, {
    data: { ...params },
    needLogin: true
  }).then(({ code, message }) => {
    if (code !== 0) {
      debounceToast(message);
    }
  });
}
